import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { TranslationTypes } from "./TranslationTypes";
import en from "./en_translation.json";
import ru from "./ru_translation.json";
import es from "./es_translation.json";
import tr from "./tr_translation.json";
import de from "./de_translation.json";
import fr from "./fr_translation.json";
import zh from "./zh_translation.json";
import ja from "./ja_translation.json";
import ko from "./ko_translation.json";

// Если забудем добавить поле в один из языков,
// здесь появится TypeScript ошибка
const resources: Record<string, { translation: TranslationTypes }> = {
    en: { translation: en },
    ru: { translation: ru },
    es: { translation: es },
    tr: { translation: tr },
    de: { translation: de },
    fr: { translation: fr },
    zh: { translation: zh },
    ja: { translation: ja },
    ko: { translation: ko },

};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "i18nextLng",
        },
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
